export const getRandomID = (salt?: string) => {
  const timeStamp = (+new Date()).toString();
  const n = timeStamp.slice(timeStamp.length - 6);
  return salt ? salt + n : n;
};

export const getRandomString = (length_ = 6) => {
  const char = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghiklmnopqrstuvwxyz';
  const chars = char.split('');
  if (typeof length_ !== 'number') {
    length_ = Math.floor(Math.random() * chars.length);
  }
  let str = '';
  for (let i = 0; i < length_; i++) {
    str += chars[Math.floor(Math.random() * chars.length)];
  }
  return str;
};

export const isArray = (arr: any) => arr instanceof Array && arr.length > 0;

export const isObject = (obj: any) =>
  obj instanceof Object && Object.keys(obj).length > 0;

export const camelize = (str: string) =>
  str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) => {
    if (+match === 0) return ''; // or if (/\s+/.test(match)) for white spaces
    return index === 0 ? match.toLowerCase() : match.toUpperCase();
  });

export const slugify = (text: string) => {
  return text
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/[^\w-]+/g, '');
};
export const titleize = (slug: string) => {
  return slug.replace(/-/g, ' ').replace(/\b[a-z]/g, (txt) => {
    return txt[0].toUpperCase();
  });
};

export const shadeColor = (color: string, percent: number) => {
  let R = parseInt(color.substring(1, 3), 16);
  let G = parseInt(color.substring(3, 5), 16);
  let B = parseInt(color.substring(5, 7), 16);

  R = (R * (100 + percent)) / 100;
  G = (G * (100 + percent)) / 100;
  B = (B * (100 + percent)) / 100;

  R = R < 255 ? R : 255;
  G = G < 255 ? G : 255;
  B = B < 255 ? B : 255;

  const RR =
    R.toString(16).length === 1 ? `0${R.toString(16)}` : R.toString(16);
  const GG =
    G.toString(16).length === 1 ? `0${G.toString(16)}` : G.toString(16);
  const BB =
    B.toString(16).length === 1 ? `0${B.toString(16)}` : B.toString(16);

  return `#${RR}${GG}${BB}`;
};
